import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const LifestyleCta = () => (
  <section data-testid="lifestyle-cta-section" className="px-5 pb-28 md:px-10 md:pb-36">
    <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto flex max-w-[1400px] flex-col items-start gap-10 border-t border-[rgba(152,191,162,0.2)] pt-16 lg:flex-row lg:items-end lg:justify-between">
      <div>
        <p className="eyebrow mb-4">Il prossimo passo</p>
        <h2 className="font-display text-5xl font-900 uppercase leading-[0.88] md:text-7xl">
          Scopri come si allena <span className="text-[#c4dcca]">lo stile di vita.</span>
        </h2>
      </div>
      <Link to="/lifestyle-training" data-testid="home-lifestyle-cta"
        className="group inline-flex shrink-0 items-center gap-3 bg-[#98bfa2] px-8 py-5 font-display text-xl font-800 uppercase text-[#050807] transition-colors hover:bg-[#c4dcca]">
        Scopri il Lifestyle Training <ArrowUpRight className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" size={22} />
      </Link>
    </motion.div>
  </section>
);
